import React, { useEffect, useRef, useState } from "react";
import {
  allColumns,
  itemsInputField as inputFieldsInit,
} from "./ListMonitor.config";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import {
  getPhongBanAPI,
  searchBHXH,
} from "../../../../../redux/reducer/employee";
import { ColumnProps } from "../../../../../types/models";
import Notification from "../../../../../components/common/notification/notification";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  ListActionButton,
  Search,
} from "../../../../../components/common";
import { Button, Col, Popover, Row, Space, Table, Typography } from "antd";
import Icons from "../../../../../assets/icons";
import { ExcelSVG } from "../../../../../assets";
import ModalCustom from "../../../../../components/common/ModalCustom/ModalCustom";
import FormAdd from "../../SalarySettings/Tab/FormAdd/FormAdd";
import axiosClient from "../../../../../api/axiosClient";
import { employeeService } from "api";
import {
  generateFileName,
  saveTableOptions,
  getTableOptions,
} from "../../../../../helper/common";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { setButtonsHeader } from "redux/reducer/common";
const ListMonitorBHXH = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  let savedTableOption = getTableOptions(
    "LISTMONITORBHXH_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumns.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;
  const [columns, setColumns] = useState<any>(
    defaultColumns.filter((e) => e.show == true)
  );
  columns.map((e) => {
    if (e.key == "index") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const [paramss, setParamss] = useState<any>({});
  const employees = useAppSelector((state) => state.employeesReducer);
  const modalRef = useRef<any>();
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const onClickSearch = async () => {
    setLoading(true);
    setCurrentPage(1);
    var searchFields = expandRef?.current?.getData();
    setParams({ ...params, ...searchFields, page: 1 }); // Đặt trang về 1 khi thực hiện tìm kiếm
    setLoading(false);
  };
  const getList = async (params) => {
    setLoading(true);
    setSelectedRowKeys([]);
    await dispatch(searchBHXH(params));
    setLoading(false);
  };
  useEffect(() =>{
    dispatch(setButtonsHeader([]));
  },[])
  const handleSave = (row: any) => {
    const newData = [...data];
    const index = newData.findIndex((item) => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setData(newData);
  };
  useEffect(() => {
    getList({
      ...params,
    });
  }, [params]);
  // useEffect(() => {
  //     getList({
  //         ...paramss,
  //     });
  // }, [paramss]);
  useEffect(() => {
    setData(
      employees.BHXHList.map((list) => ({
        ...list,
        key: list.id,
      }))
    );
  }, [employees.BHXHList]);

  // useEffect(() => {
  //   setColumns(
  //     allColumns
  //       .map((col) => {
  //         if (!col.editable) {
  //           if (col.dataIndex === "index") {
  //             return {
  //               title: "STT",
  //               key: "index",
  //               show: true,
  //               dataIndex: "index",
  //               render(_, __, index) {
  //                 return <>{index + 1 + (params.page - 1) * params.limit}</>;
  //               },
  //               fixed: "left",
  //               width: 50,
  //               align: "center",
  //               isResizable: true,
  //             };
  //           } else {
  //             return col;
  //           }
  //         }
  //         return {
  //           ...col,
  //           onCell: (record: any) => ({
  //             record,
  //             editable: true,
  //             dataIndex: col.dataIndex,
  //             title: col.title,
  //             handleSave,
  //           }),
  //         };
  //       })
  //       .filter((e) => e.show == true)
  //   );
  // }, [data]);

  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };
  const setShowColumnsList = (showColumns) => {
    saveTableOptions(
      "LISTMONITORBHXH_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({ ...params, page: currentPage, limit: pageSize });
  };
  const onClickExport = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({ ...paramss, ...searchFields });
    handleExportExcel(params);
  };

  const handleExportExcel = async (params) => {
    const url = "hanhchinhnhansu/theo-doi-bhxh/export-excel";
    const baseName = "danh-sach-theo-doi-bhxh";
    const fileExtension = "xlsx";
    const fileName = generateFileName(baseName, fileExtension);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("error", "Error exporting Excel");
    }
  };
  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    
    if (event.target.files && event.target.files.length > 0) {
      const excel = event.target.files[0];
      
      const formData = new FormData();
      formData.append("files", excel);
      try {
        const response = await employeeService.uploadChamCong(formData);
        if (response.status == 200) {
        }
        Notification("success", "Tải lên file excel thành công");
      } catch (err) {
        Notification("error", "Lỗi khi tải lên file excel");
      }
    }
  };
  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  useEffect(() => {
    dispatch(
      getPhongBanAPI({
        page: 1,
        limit: 100,
      })
    );
  }, []);
  useEffect(() => {
    setOptionsPBFields(employees.phongBanList, "idPhongBan");
  }, [employees.phongBanList]);
  const setOptionsPBFields = (list, tenPhongBan) => {
    if (inputFieldsInit.find((field) => field.name === tenPhongBan)) {
      inputFieldsInit.find((field) => field.name === tenPhongBan).options =
        list?.map((item) => ({
          value: item.id,
          label: item.tenPhongBan,
        }));
    }
  };
  const handleSubmit = async () => {
    try {
      (data);
      const res = await employeeService.updateChamCong(data);
      getList(params);
      Notification("success", "Cập nhập thành công ");
    } catch (res) {
      Notification("error", "Cập nhập thất bại");
    }
  };
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  // Xác định độ dài của mảng columns
  const numberOfColumns = columns.length;

  const deleteCauHinhLuong = async (id) => {
    try {
      const res = await employeeService.deleteCauHinhLuong(id);
      Notification("success", "Đã xóa dữ liệu vừa chọn");

      getList(params);
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi xóa dữ liệu");
    }
  };

  return (
    <div className="recruitment-list" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="recruitment-container">
        <div className="container">
          <ExpandSearch
            ref={expandRef}
            fields={inputFieldsInit}
            onClickSearch={onClickSearch}
            // Ẩn nút "Tìm kiếm nâng cao"
            isSearchExpend={false}
            isResetField={false}
          />
        </div>
        <div className="container">
          <Space style={{ width: "100%" }} direction="vertical">
            {/*<Typography.Text strong>Danh sách nhân viên</Typography.Text>*/}
            {/*<Divider type="horizontal" style={{ margin: "0" }} />*/}
            <Row justify={"space-between"} gutter={[16, 8]}>
              <Col>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={columns}
                      width={"400px"}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button
                    icon={<Icons.bars rev={0} />}
                    className="btn-sub"
                    type="ghost"
                  >
                    Cột hiển thị
                  </Button>
                </Popover>
              </Col>
              <Col>
                <Space style={{ width: "100%" }}>
                  <Button
                    className="custom-btn"
                    type="default"
                    onClick={onClickExport}
                    icon={<ExcelSVG />}
                  >
                    <Typography>Xuất báo cáo</Typography>
                  </Button>
                  {/* <input
                                        type="file"
                                        style={{ display: "none" }}
                                        onChange={handleUpload}
                                        ref={fileInputRef}
                                    /> */}
                  {/* <Button

                                        icon={<Icons.upload rev={0}/>}
                                        className="btn-sub"
                                        type="ghost"
                                        onClick={handleClick}
                                        style={{
                                            width: "100px",
                                        }}
                                    >Import</Button> */}
                </Space>
              </Col>
            </Row>
            {data && (
              <CustomResizableTable
                // rowSelection={{
                //   type: "radio",
                //   ...rowSelection,
                // }}
                setShowColumns={setShowColumnsList}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: employees.BHXHTotal,
                  onChange: onChangePagination,
                  current: currentPage,
                }}
                onRow={(record, rowIndex) => {
                  return {
                    // onDoubleClick: e => handleView(record.id),
                  };
                }}
                rowKey={(record) => record.id}
                columns={columns}
                dataSource={data}
                bordered={true}
                loading={loading}
                scroll={{ x: 1200 }}
              />
            )}
          </Space>
        </div>
      </div>
    </div>
  );
};

export default ListMonitorBHXH;
